import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { AppBlockedComponent } from "../components/Layout/Splash/AppBlockedComponent/AppBlockedComponent";
import { globalTranslationFiles } from "../utils/help/localization/localization";

function CookieCheckPage() {
  return (
    <div data-testid="cookie-check-component">
      <AppBlockedComponent />
    </div>
  );
}

export async function getStaticProps({ locale }: { locale: any }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, [
        ...globalTranslationFiles,
        "common",
      ])),
      // Will be passed to the page component as props
    },
  };
}

CookieCheckPage.displayName = "CookieCheckPage";

export default CookieCheckPage;
